<ion-app>
  <ion-menu contentId="main-content" menuId="main-menu" type="overlay">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-menu-toggle auto-hide="true">
          <ion-item routerLink="/home" routerDirection="root">Home</ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="true">
          <ion-item routerLink="/privacy" routerDirection="root">Legal</ion-item>
        </ion-menu-toggle>
        <ion-menu-toggle auto-hide="true">
          <ion-item routerLink="/contact" routerDirection="root">Contact</ion-item>
        </ion-menu-toggle>
      </ion-list>
      <ion-item lines="none">
        <ion-label>Big Red Button theme</ion-label>
        <ion-toggle
          slot="end"
          data-testid="brb-theme-toggle"
          [checked]="bigRedThemeActive"
          (ionChange)="toggleBigRedTheme($event)"
          aria-label="Toggle the Big Red Button theme"
        ></ion-toggle>
      </ion-item>
      <ion-item lines="none" class="menu-subitem">
        <ion-label>Advanced options</ion-label>
        <ion-toggle
          slot="end"
          data-testid="advanced-options-toggle"
          [checked]="advancedOptionsEnabled"
          (ionChange)="toggleAdvancedOptions($event)"
          aria-label="Toggle advanced options"
        ></ion-toggle>
      </ion-item>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>

  <ion-modal
    [isOpen]="showConsentModal"
    aria-label="Cookie preferences"
    [backdropDismiss]="true"
    [keyboardClose]="true"
    (didDismiss)="closeConsentModal()"
    data-testid="cookie-consent-modal"
  >
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Cookie Preferences</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="consent-modal">
        <p>
          We use necessary cookies/local storage to run this site. Analytics and advertising cookies are enabled by
          default. You can opt out here at any time.
        </p>
        <ion-list>
          <ion-item>
            <ion-label>
              <strong>Necessary</strong>
              <p>Always on. Required for core functionality.</p>
            </ion-label>
            <ion-toggle [checked]="true" [disabled]="true" aria-label="Necessary cookies always on"></ion-toggle>
          </ion-item>
          <ion-item *ngIf="showConsentCustomization">
            <ion-label>
              <strong>Analytics</strong>
              <p>Helps us understand usage. You can turn this off.</p>
            </ion-label>
            <ion-checkbox slot="end" [(ngModel)]="consentAnalytics" aria-label="Analytics cookies"></ion-checkbox>
          </ion-item>
          <ion-item *ngIf="showConsentCustomization">
            <ion-label>
              <strong>Advertising/Tracking</strong>
              <p>Supports relevant ads and tracking. You can turn this off.</p>
            </ion-label>
            <ion-checkbox slot="end" [(ngModel)]="consentAds" aria-label="Advertising cookies"></ion-checkbox>
          </ion-item>
        </ion-list>
        <div class="consent-modal__actions">
          <ion-button size="small" (click)="acceptAllConsent()">Accept all</ion-button>
          <ion-button size="small" fill="outline" (click)="rejectAllConsent()">Reject non-essential</ion-button>
          <ion-button
            size="small"
            fill="clear"
            *ngIf="!showConsentCustomization"
            (click)="showConsentCustomization = true"
          >
            Customize
          </ion-button>
          <ion-button size="small" fill="clear" *ngIf="showConsentCustomization" (click)="saveCustomConsent()">
            Save preferences
          </ion-button>
          <ion-button size="small" fill="clear" (click)="closeConsentModal()">Close</ion-button>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-app>
